"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapPageElement;
var _react = _interopRequireDefault(require("react"));
var _components = require("@bluefin/components");
var DEFAULT_CHOWNOW_SCRIPT_URL = 'https://cf.chownowcdn.com/latest/static/integrations/ordering-modal.min.js';
function wrapPageElement(_ref, pluginOptions) {
  var element = _ref.element;
  var chowNowUrl = pluginOptions.chowNowUrl,
    chowNowHqid = pluginOptions.chowNowHqid,
    _pluginOptions$produc = pluginOptions.productionOnly,
    productionOnly = _pluginOptions$produc === void 0 ? false : _pluginOptions$produc,
    _pluginOptions$strate = pluginOptions.strategy,
    strategy = _pluginOptions$strate === void 0 ? _components.Script.DEFAULT_SCRIPT_LOAD_STRATEGY : _pluginOptions$strate,
    _pluginOptions$target = pluginOptions.targetSelector,
    targetSelector = _pluginOptions$target === void 0 ? _components.Script.DEFAULT_TARGET_SELECTOR : _pluginOptions$target;
  if (!pluginOptions || !chowNowHqid) {
    throw new Error('ChowNow HQID is missing');
  }
  var finalChowNowUrl = chowNowUrl || DEFAULT_CHOWNOW_SCRIPT_URL;
  if (!productionOnly || process.env.NODE_ENV === 'production') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, element, /*#__PURE__*/_react["default"].createElement(_components.Script, {
      key: chowNowHqid,
      strategy: strategy,
      targetSelector: targetSelector,
      src: finalChowNowUrl,
      "data-chownow-company-id": chowNowHqid
    }));
  }
  return element;
}